<div class="colimind-layout">


  @if (showOnboarding()) {
    <colimo-onboarding [userName]="userName()" (termsAccepted)="onTermsAccepted()" (completed)="onOnboardingCompleted()" />
  }

  <!-- Not rendered at all during the onboarding, so hiding the overlay does not unlock the chat -->
  @if (chatReady()) {
  <!-- Vertical icon strip -->
  <nav class="icon-strip">
    <button
      mat-icon-button
      [matTooltip]="panelOpen() ? ('colimind.closePanel' | translate) : ('colimind.openPanel' | translate)"
      matTooltipPosition="right"
      (click)="togglePanel()"
      [class.icon-strip__btn--active]="panelOpen() && panelMode() === 'history'"
      >
      <mat-icon>
        <svg viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
          <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-80v-560H200v560h120Zm80 0h360v-560H400v560Zm-80 0H200h120Z" />
        </svg>
      </mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'colimind.newSession' | translate"
      matTooltipPosition="right"
      (click)="onNewSession()"
      >
      <mat-icon>add</mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'colimind.searchSessions' | translate"
      matTooltipPosition="right"
      (click)="openPanel('search')"
      [class.icon-strip__btn--active]="panelOpen() && panelMode() === 'search'"
      >
      <mat-icon>search</mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'colimind.history' | translate"
      matTooltipPosition="right"
      (click)="openPanel('history')"
      [class.icon-strip__btn--active]="panelOpen() && panelMode() === 'history'"
      >
      <mat-icon>history</mat-icon>
    </button>

    <button
      mat-icon-button
      [matTooltip]="'colimind.settings' | translate"
      matTooltipPosition="right"
      (click)="openPanel('settings')"
      [class.icon-strip__btn--active]="panelOpen() && panelMode() === 'settings'"
      >
      <mat-icon>settings</mat-icon>
    </button>

  </nav>

  <!-- Sidenav: expandable panel + main content -->
  <mat-sidenav-container class="colimind-sidenav-container">
    <mat-sidenav
      mode="side"
      [opened]="panelOpen()"
      class="colimind-sidenav"
      disableClose
      >
      <div class="colimind-panel-inner">

        @if (panelMode() === 'search') {
          <div class="colimind-panel-search">
            <mat-form-field appearance="outline" class="search-field">
              <mat-icon matPrefix>search</mat-icon>
              <input
                matInput
                [ngModel]="searchQuery()"
                (ngModelChange)="searchQuery.set($event)"
                name="search"
                autocomplete="off"
                [placeholder]="'colimind.searchPlaceholder' | translate"
                />
              </mat-form-field>
            </div>
            <div class="colimind-panel-content">
              <colimo-session-list
                [sessions]="filteredSessions()"
                [emptyMessageKey]="searchQuery().trim() ? 'colimind.noSearchResults' : 'colimind.noSessions'"
                [activeSessionId]="activeSessionId()"
                (selectSession)="onSelectSession($event); panelOpen.set(false)"
                (deleteSession)="onDeleteSession($event)"
                (deleteAllSessions)="onDeleteAllSessions()"
                />
              </div>
            }

            @if (panelMode() === 'history') {
              <div class="colimind-panel-header">
                <p class="panel-label">{{ 'colimind.history' | translate }}</p>
              </div>
              <div class="colimind-panel-content">
                <colimo-session-list
                  [sessions]="sessions()"
                  [activeSessionId]="activeSessionId()"
                  (selectSession)="onSelectSession($event); panelOpen.set(false)"
                  (deleteSession)="onDeleteSession($event)"
                  (deleteAllSessions)="onDeleteAllSessions()"
                  />
                </div>
              }

              @if (panelMode() === 'settings') {
                <colimo-settings-panel />
              }

            </div>
          </mat-sidenav>

          <mat-sidenav-content class="colimind-content">
            @if (messages().length === 0 && !loading()) {
              <colimo-dashboard
                [highlightInput]="spotlight()"
                [userName]="userName()"
                [suggestions]="activeSuggestions()"
                [quickActions]="activeDefaults()"
                [chatNotFound]="chatNotFound()"
                (send)="onSend($event)"
                (demo)="onDemo($event)"
                />
            }

            @if (messages().length > 0 || loading()) {
              <colimo-chat-window
                [highlightInput]="spotlight()"
                [messages]="messages()"
                [loading]="loading()"
                [status]="streamStatus()"
                (send)="onSend($event)"
                (answerQuestions)="onAnswerQuestions($event.message, $event.answers)"
                (stop)="onStop()"
                (saveAsSuggestion)="onSaveAsSuggestion($event)"
                />
            }
          </mat-sidenav-content>
        </mat-sidenav-container>
  }

      </div>
